// Console debug silencer — must be imported FIRST in main.tsx (before App)
// Silences console.log/debug/warn in production for end users.
// Team access: visit app.okostec.ai?dx=TOKEN to enable console output.
// Docs: docs/System-Logging.md → "Frontend Console Debug Mode"
if (import.meta.env.PROD) {
  const DX_KEY = '__okos_dx';
  const DX_TOKEN = import.meta.env.VITE_TEAM_DEBUG_TOKEN;
  try {
    const params = new URLSearchParams(window.location.search);
    if (DX_TOKEN && params.get('dx') === DX_TOKEN) {
      localStorage.setItem(DX_KEY, DX_TOKEN);
      // Strip ONLY the `dx` param so other query params survive (e.g.
      // `?from=…` for Phase B.3, or anything the security-monitoring
      // listener needs to inspect). Previous behavior wiped the entire
      // query string, which silently killed downstream observers.
      params.delete('dx');
      const remaining = params.toString();
      const newUrl =
        window.location.pathname + (remaining ? `?${remaining}` : '') + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
    if (!DX_TOKEN || localStorage.getItem(DX_KEY) !== DX_TOKEN) {
      console.log = () => {};
      console.debug = () => {};
      console.warn = () => {};
    }
  } catch {
    console.log = () => {};
    console.debug = () => {};
    console.warn = () => {};
  }
}
